module.exports = __webpack_public_path__ + "img/img-event-tab-04.00963c04.png";